import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DocumentChecklistDto } from 'src/app/models/hyarchisChecklist';
import { DossierTypeChecklistItemDto } from 'src/app/models/hyarchisDossierTypeChecklistItem';

@Component({
    selector: 'app-cloud-export-checklist-item',
    templateUrl: './cloud-export-checklist-item.component.html',
    styleUrls: ['./cloud-export-checklist-item.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CloudExportChecklistItemComponent {
  @Input() firstItem: boolean = false;
  @Input() lastItem: boolean = false;
  @Input() disabled: boolean = false;
  @Input() document: DocumentChecklistDto | null = null;
  @Input() checklistItems: DossierTypeChecklistItemDto[] = [];
  @Output() selectedChecklistItemId: EventEmitter<number> = new EventEmitter<number>();
  // Correct Input setter implementation
  @Input()
  set setChecklistItem(id: number | null) {
    if (this.document) {
      this.document.checklistItemId = id;
    }
  }

  public get NotSet(): boolean {
    return this.document != null && this.document.checklistItemId != null && this.document.checklistItemId != -1;
  }
  public getCheckListItemValue(checklistItemId: number | null) {
    if (checklistItemId === null) {
      return "Unassigned";
    }
    const item = this.checklistItems.find(ci => ci.checklistItemId === checklistItemId);
    return item ? item.checklistItemName : "Unknown Item";
  }

  public changeCheckListItem(checklistItemId: number | null) {
    if (this.document) {
      this.document.checklistItemId = checklistItemId;
    }
    this.selectedChecklistItemId.emit(checklistItemId ?? -1);
  }


}